// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__-qgHS","errorLogs":"EditorFooter_errorLogs__2wj5n"};